import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c24c670"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "roles-view" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-3 mb-3" }, "No variables have been created in the template so far.", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "mb-1" }
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = ["onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!Object.keys(_ctx.variables).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.variables), (key) => {
      return (_openBlock(), _createElementBlock("div", {
        key: key,
        class: "user-selection-wrapper mb-2"
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.computedVariables[key].name) + ":", 1),
            (_ctx.computedVariables[key].type === 'STRING')
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  placeholder: "Variable Value",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.computedVariables[key].value) = $event)
                }, null, 8, _hoisted_8)), [
                  [_vModelText, _ctx.computedVariables[key].value]
                ])
              : _createCommentVNode("", true),
            (_ctx.computedVariables[key].type === 'NUMBER')
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  type: "number",
                  placeholder: "01234",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.computedVariables[key].value) = $event)
                }, null, 8, _hoisted_9)), [
                  [_vModelText, _ctx.computedVariables[key].value]
                ])
              : _createCommentVNode("", true),
            (_ctx.computedVariables[key].type === 'LINK')
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 2,
                  type: "text",
                  placeholder: "Link Label",
                  class: "mb-3",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.computedVariables[key].label) = $event)
                }, null, 8, _hoisted_10)), [
                  [_vModelText, _ctx.computedVariables[key].label]
                ])
              : _createCommentVNode("", true),
            (_ctx.computedVariables[key].type === 'LINK')
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 3,
                  type: "text",
                  placeholder: "https://www...",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.computedVariables[key].value) = $event)
                }, null, 8, _hoisted_11)), [
                  [_vModelText, _ctx.computedVariables[key].value]
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    }), 128))
  ]))
}